import { computed, inject, Injectable, Signal } from '@angular/core';

import { LanguagesService } from '@ppg/core/language';

import { TranslatedText } from '../models';

@Injectable({ providedIn: 'root' })
export class TranslationTextService {
  readonly #languagesService = inject(LanguagesService);

  getText(texts?: TranslatedText[]): Signal<string> {
    return computed(() => this.getTranslatedText(texts));
  }

  getTranslatedText(texts: TranslatedText[] | null | undefined): string {
    if (!texts) {
      return '';
    }
    const currentLang = this.#languagesService.language();
    return texts.find((text) => text.Language === currentLang)?.Translation ?? '';
  }
}
